
import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';

import { getImagesByQuery } from './js/pixabay-api.js';
import { 
  createGallery, 
  clearGallery, 
  showLoader, 
  hideLoader,
  showLoadMoreButton,
  hideLoadMoreButton
} from './js/render-functions.js';

const form = document.querySelector('.form');
const searchInput = form.querySelector('input[name="search-text"]');
const loadMoreButton = document.querySelector('.load-more');
const gallery = document.querySelector('.gallery');

let currentQuery = '';
let currentPage = 1;
let totalHits = 0;
let loadedImages = 0;

form.addEventListener('submit', onFormSubmit);
loadMoreButton.addEventListener('click', onLoadMoreClick);

async function onFormSubmit(event) {
  event.preventDefault();

  const query = searchInput.value.trim();

  // Перевірка на порожній рядок
  if (query === '') {
    iziToast.warning({
      title: 'Warning',
      message: 'Please enter a search query!',
      position: 'topRight'
    });
    return;
  }

  // Скидаємо пагінацію для нового пошуку
  currentQuery = query;
  currentPage = 1;
  totalHits = 0;
  loadedImages = 0;

  // Очищаємо попередню галерею
  clearGallery();

  // Ховаємо кнопку Load more
  hideLoadMoreButton();

  // Показуємо лоадер
  showLoader();

  try {
    const data = await getImagesByQuery(currentQuery, currentPage);

    // Ховаємо лоадер
    hideLoader();

    // Перевіряємо чи є результати
    if (data.hits.length === 0) {
      iziToast.error({
        title: 'Error',
        message: 'Sorry, there are no images matching your search query. Please try again!',
        position: 'topRight'
      });
      return;
    }

    totalHits = data.totalHits;
    loadedImages = data.hits.length;

    createGallery(data.hits);

    // Перевіряємо чи потрібно показувати кнопку Load more
    checkLoadMoreButton();

    form.reset();

  } catch (error) {
    hideLoader();
    
    iziToast.error({
      title: 'Error',
      message: 'Something went wrong. Please try again later!',
      position: 'topRight'
    });
    
    console.error('Error fetching images:', error);
  }
}

async function onLoadMoreClick() {
  // Збільшуємо номер сторінки
  currentPage += 1;

  showLoader();
  try {
    const data = await getImagesByQuery(currentQuery, currentPage);
    hideLoader();

    loadedImages += data.hits.length;

    createGallery(data.hits);

    smoothScroll();

    // Перевіряємо чи потрібно показувати кнопку Load more
    checkLoadMoreButton();

  } catch (error) {
    hideLoader();
    
    iziToast.error({
      title: 'Error',
      message: 'Something went wrong. Please try again later!',
      position: 'topRight'
    });
    
    console.error('Error fetching images:', error);
  }
}

function checkLoadMoreButton() {
  // Перевіряємо чи є ще зображення для завантаження
  if (loadedImages >= totalHits) {
    // Досягнуто кінця колекції
    hideLoadMoreButton();
    
    // Показуємо повідомлення тільки якщо було завантажено більше ніж одну сторінку
    if (currentPage > 1) {
      iziToast.info({
        title: 'Info',
        message: "We're sorry, but you've reached the end of search results.",
        position: 'topRight'
      });
    }
  } else {
    // Є ще зображення - показуємо кнопку
    showLoadMoreButton();
  }
}

function smoothScroll() {
  const galleryItem = gallery.querySelector('.gallery-item');
  
  if (galleryItem) {
    const cardHeight = galleryItem.getBoundingClientRect().height;
    
    window.scrollBy({
      top: cardHeight * 2,
      behavior: 'smooth'
    });
  }
}